module.exports = __webpack_public_path__ + "static/img/no_data_bar.09569672.svg";